/**
 * Adds a click-outside listener to a target element.
 *
 * @param {HTMLElement} element - The element to detect outside clicks for
 * @param {(event: MouseEvent) => void} handler - The function to call on outside click
 * @returns {() => void} A cleanup function to remove the event listener
 */
export const onClickOutside = (element, handler) => {
  function handleClick(e) {
    if (!element.contains(e.target)) {
      handler(e);
    }
  }

  document.addEventListener('click', handleClick);

  return () => {
    document.removeEventListener('click', handleClick);
  };
};
